export default {
    MIN_WIDTH: {
        BASE: 58,
        SM: 46
    }
};
